var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReportsIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.58334 21.5833H14.5833M7.58334 21.5833V15.75M7.58334 21.5833H1.28334C1.09769 21.5833 0.919644 21.5096 0.788369 21.3783C0.657093 21.247 0.583344 21.069 0.583344 20.8833V16.45C0.583344 16.2643 0.657093 16.0863 0.788369 15.955C0.919644 15.8237 1.09769 15.75 1.28334 15.75H7.58334M14.5833 21.5833V7.58333M14.5833 21.5833H20.8833C21.069 21.5833 21.247 21.5096 21.3783 21.3783C21.5096 21.247 21.5833 21.069 21.5833 20.8833V1.28333C21.5833 1.09768 21.5096 0.919633 21.3783 0.788357C21.247 0.657082 21.069 0.583332 20.8833 0.583332H15.2833C15.0977 0.583332 14.9196 0.657082 14.7884 0.788357C14.6571 0.919633 14.5833 1.09768 14.5833 1.28333V7.58333M7.58334 15.75V8.28333C7.58334 8.09768 7.65709 7.91963 7.78837 7.78836C7.91964 7.65708 8.09769 7.58333 8.28334 7.58333H14.5833",
    stroke: "#352890",
    strokeWidth: 1.16667
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsIconBlue);
export default __webpack_public_path__ + "static/media/ReportsIconBlue.4387ad0762eda5bec8b74354ed41cd6b.svg";
export { ForwardRef as ReactComponent };